import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sarbajaya_lang") || "en");

  useEffect(() => {
    localStorage.setItem("sarbajaya_lang", lang);
    document.documentElement.lang = lang === "bn" ? "bn" : "en";
    if (lang === "bn") document.body.classList.add("lang-bn");
    else document.body.classList.remove("lang-bn");
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    t: translations[lang],
  }), [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
